export const CHAT_SUPPORT = 'support';
export const CHAT_MARKETER = 'marketer';

/** Последний открытый чат (между сессиями). Очищается при логауте. */
export const LAST_CHAT_ID_KEY = 'last_chat_id';
export const CHAT_BLOCKED_PREFIX = 'chat.blocked.';
export const CHAT_MODAL_POSITION_KEY = 'chat_modal_position';
